<template>
    <div>
        <first />
        <second />
        <third />
        <fourth />
        <fifth />
        <sixth />
        <seventh />
    </div>
</template>

<script src="./oracleImplementation.js"></script>
<style src="./oracleImplementation.css"></style> 